export default __webpack_public_path__ + "static/media/hip.15940fcf.svg";